import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./ProjectsDetails.css";



function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [related, setRelated] = useState([]);
  const [showContribute, setShowContribute] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  const projectStages = [
    "Idea",
    "Viability",
    "POC",
    "Beta",
    "Launch",
    "Expansion",
    "Maturity",
  ];

  const fundingStages = [
    "Pre-seed",
    "Seed",
    "Angel",
    "Venture Capital",
    "IPO",
  ];

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    fetch("https://indodeftech.com/api/projects")
      .then((response) => response.json())
      .then((data) => {
        const allProjects = data.lists || [];
        const match = allProjects.find((item) => String(item.id) === String(id));
        if (match) {
          setProject(match);
          document.title = match.title + " - IndoDef Tech";
        }
        const relatedItems = allProjects
          .filter((item) => String(item.id) !== String(id))
          .sort(() => 0.5 - Math.random())
          .slice(0, 3);
        setRelated(relatedItems);
      })
      .catch((err) => console.error("Error loading project:", err));
  }, [id]);

  if (!project) {
    return (
      <div className="w3-center w3-padding-large">
        <p>Loading project details...</p>
      </div>
    );
  }

  const activeProjectStageIndex = projectStages.findIndex(
    (s) => s.toLowerCase() === (project.project_stage || "").trim().toLowerCase()
  );
  const activeFundingStageIndex = fundingStages.findIndex(
    (s) => s.toLowerCase() === (project.funding_stage || "").trim().toLowerCase()
  );

  const handleContributeSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("project_id", project.id);
    formData.append("project_title", project.title);

    try {
      const res = await fetch("https://indodeftech.com/api/contribute", {
        method: "POST",
        body: formData,
      });
      const text = await res.text();
      const data = JSON.parse(text);
      if (data.success) {
        setShowContribute(false);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2500);
        e.target.reset();
      } else {
        alert(data.error || "Error submitting contribution");
      }
    } catch (err) {
      console.error("Error submitting contribution:", err);
      alert("Error submitting contribution.");
    }
  };


  const images =
    project.images && typeof project.images === "object"
      ? Object.values(project.images).filter((img) => !!img)
      : project.image
      ? [project.image]
      : [];


  const handleBack = () => {
    const scrollY = location.state?.scrollY || sessionStorage.getItem("scrollY") || 0;
    navigate("/projects", { state: { scrollY: parseInt(scrollY) } });
  };

  return (
    <div className="w3-margin-top w3-content w3-animate-opacity">


      {/* Header Section with Image Slider */}
      <div className=" w3-white w3-card w3-round-large w3-padding">

       <table className="" style={{width: '100%'}}>
       <tr>
       <td>
        <i 
        onClick={handleBack} className="w3-button w3-light-gray btn-sm fa fa-arrow-left"></i>
       </td>
       <td>
<span className="w3-right w3-small "># {project.id} </span></td>
       </tr>
     </table>


 <div className="w3-row"> 
 <h2 className="w3-800">{project.title}</h2> 
  <p className="w3-text-grey">{project.short_description}</p>
</div>

      <div className="w3-row w3-padding-16">

        <div className="w3-col l7 m12 s12">
          {images.length > 0 ? (
            <div className="w3-display-container">
              {images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  className="mySlides w3-animate-opacity w3-round-large"
                  alt={`Project Slide ${idx + 1}`}
                  style={{
                    width: "100%",
                    height: "500px",
                    objectFit: "cover",
                    display: idx === 0 ? "block" : "none",
                  }}
                />
              ))}
              {images.length > 1 && (
                <>
                  <button
                    className="w3-button w3-black w3-display-left"
                    onClick={() => plusDivs(-1)}
                  >
                    ❮
                  </button>
                  <button
                    className="w3-button w3-black w3-display-right"
                    onClick={() => plusDivs(1)}
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          ) : (
            <div className="w3-center w3-padding w3-text-grey">No images available</div>
          )}


        </div>

        <div className="w3-col l4 m12 s12 w3-right ">

          <p>
            <strong className="w3-text-grey w3-small">Industry</strong>
             <br /><span className="w3-large w3-text-blue w3-600 ">{project.industry_stage || "N/A"}</span>
          </p>

          <p>
            <strong className="w3-text-grey w3-small">Technology</strong> <br /><span className="w3-large w3-text-blue w3-600 ">{project.technology || "N/A"}</span>
          </p>


      <table className="" style={{width: '100%'}}>
     <tr>
      <td colspan="2">

      <strong className="w3-left w3-text-grey w3-small">Angel Round</strong>
      <span className="w3-text-gray w3-small w3-right">
      <i className="w3-text-gray fa fa-inr"> 5,00,00,000 </i> </span>
      </td>
      </tr>

      <tr>
      <td colspan="2">
       <div className="progress-container"> 
      <div className="progress-bar">
      <div className="progress-fill" style={{ width: `60%` }}>
      </div>
      </div>
      </div> 
      </td>
      </tr>

      <tr>
      <td> 

      <span className="w3-text-grey w3-small">Pledged 60%</span><br />
      <span className="w3-large w3-text-blue w3-600 ">{project.angel_achieved || "20,00,000"}</span>
      <br />
      <span className="w3-text-grey w3-small">60 Days</span>
      </td>

      <td  className="w3-right">
      <span className="w3-text-grey w3-small">Remaining 40%</span><br />
      <span className="w3-large w3-text-blue w3-600 ">{project.angel_target || "50,00,000"}</span>
      <br />
      <span className="w3-text-grey w3-small">40 days left</span>
      </td>
      </tr>
      </table>

           <p>
  <button
    onClick={() => {
      const target = document.getElementById("join-form");
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    }}
    className="w3-button w3-teal w3-padding-large w3-col l12"
    style={{ fontWeight: 600, textAlign: "center" }}
  >
   Promote this Project !
  </button>
</p>

    
<p>
      <br />    <hr />

          <h6 className="w3-small w3-text-gray">Join the Vision. Build the Future. Be part of a growing project, a visionary team, and a future built together.</h6>
          <span className="w3-text-blue w3-small"> Angel Investment Terms & agreement</span>
</p>

        </div>

      </div>


      {/* ✅ Video Section */}
      <div className="w3-row w3-padding-32 w3-hide">
        <h5 className="w3-600 w3-border-bottom w3-text-blue">Project Video</h5>
        {project.video_link ? (
          <div className="w3-center w3-margin-top">
            <iframe
              width="100%"
              height="400"
              src={project.video_link.replace("watch?v=", "embed/")}
              title="Project Video"
              frameBorder="0"
              allowFullScreen
              className="w3-round-large"
            ></iframe>
          </div>
        ) : (
          <h6>No video available for this project.</h6>
        )}
      </div>

<div className="w3-row w3-padding">
        <h5 className="w3-600 w3-border-bottom  w3-text-blue">
          Vision
        </h5>

        <p>
         {project.vision ||  ""}
        </p>
</div>


<div className="w3-row w3-padding">
             <h5 className="w3-600   w3-text-blue">
          Roadmap
        </h5>

      <table className="w3-small w3-table w3-table-all" style={{width: '100%'}}>

      <tr>
      <td>
      Year-1
      </td>
      <td>
       {project.rmy1 ||  ""}
      </td>
      </tr>

      <tr>
      <td>
      Year-2
      </td>
      <td>
       {project.rmy2 ||  ""}
      </td>
      </tr>

       <tr>
      <td>
      Year-3
      </td>
      <td>
       {project.rmy3 ||  ""}
      </td>
      </tr>

      <tr>
      <td>
      Year-4
      </td>
      <td>
       {project.rmy4 ||  ""}
      </td>
      </tr>

<tr>
      <td>
      Year-5
      </td>
      <td>
       {project.rmy5 ||  ""}
      </td>
      </tr>

   
      </table>



</div>


  


      {/* ✅ Project Stage Tracker */}
      <div className="w3-row w3-padding">
        <h5 className="w3-600 w3-border-bottom  w3-text-blue">
          Project Stages
        </h5>
        <div className="stage-tracker responsive">
          {projectStages.map((stage, index) => {
            const active = index <= activeProjectStageIndex;
            return (
              <div key={stage} className={`stage-step ${active ? "active" : ""}`}>
                <div className="circle">{index + 1}</div>
                <div className="stage-info">
                  <span className="stage-title">{stage}</span>
                </div>
                {index < projectStages.length - 1 && <div className="connector"></div>}
              </div>
            );
          })}
        </div>
      </div>

      {/* ✅ Funding Stages */}
      <div className="w3-padding">
        <h5 className="w3-600 w3-border-bottom  w3-text-blue">
          Funding Stages
        </h5>
        <div className="stage-tracker responsive small">
          {fundingStages.map((stage, index) => (
            <div
              key={stage}
              className={`stage-step ${
                index <= activeFundingStageIndex ? "active" : ""
              }`}
            >
              <div className="circle small">{index + 1}</div>
              <div className="stage-info">
                <span className="stage-title">{stage}</span>
              </div>
              {index < fundingStages.length - 1 && <div className="connector"></div>}
            </div>
          ))}
        </div>
      </div>


      {/* ✅ Description Section */}
     <div className="w3-row w3-padding">
  <h5 className="w3-border-bottom w3-600 w3-text-blue">Description</h5>
  {project.description ? (
    <div dangerouslySetInnerHTML={{ __html: project.description }} />
  ) : (
    <p>Description coming soon...</p>
  )}
</div>


      {/* ✅ Research & Academia Section */}
      <div className="w3-padding">
        <h5 className="w3-600 w3-border-bottom w3-text-blue">
          Research & Academia 
        </h5>
        <p>
         {project.category ||  "IndoDef Tech actively collaborates with research institutions, universities."}
        </p>
      </div>

        {/* ✅ more information */}
      <div className="w3-padding">
        <h5 className="w3-600 w3-border-bottom w3-text-blue">
          More Information
        </h5>
        <p>
         {project.client ||  ""}
        </p>
      </div>


     
<center>
          <ul className="w3-text-gray w3-center" style={{ display: 'flex', justifyContent: 'center', gap: '1rem', listStyleType: 'none', padding: 0 }}>
          <li>Likes <i className="w3-text-blue fa fa-thumbs-up"></i> 256</li>
          <li>Viewed <i className="w3-text-teal fa fa-eye"></i> </li>
          </ul>

          </center>

      {/* ✅ Interest Form Section */}

      <div className="w3-center w3-margin-top  ">

     <section class="banner-section">
  <div class="banner-content">
    <h1>Join the Vision. Build the Future.</h1>
    <p class="subheading">
      Entrepreneurs, Leaders, Investors, Researchers, Institutions, Interns<br /> this is your invitation to co-create a project that grows with you.
    </p>
    <div class="roles">
      <div class="role-card">
        <h3>👩 Entrepreneur</h3>
        <p>Shape new modules, test market fit, and drive innovation. Your agility fuels our evolution.</p>
      </div>
      <div class="role-card">
        <h3><i className="fa fa-user"></i>Leader</h3>
        <p>Architect systems, guide teams, and set direction. Your leadership powers our velocity.</p>
      </div>
      <div class="role-card">
        <h3>💰 Investor</h3>
        <p>Support a high-potential ecosystem with real traction. Your capital and insight accelerate scale.</p>
      </div>
      <div class="role-card">
        <h3><i className="fa fa-user"></i>Researcher</h3>
        <p>Validate models, publish insights, and explore new frameworks. Your rigor strengthens our foundation.</p>
      </div>
      <div class="role-card">
        <h3><i className="fa fa-bank"></i> Institutional Setup</h3>
        <p>Partner to expand infrastructure, compliance, and reach. Your systems make us resilient.</p>
      </div>
      <div class="role-card">
        <h3><i className="fa fa-user"></i> Interns </h3>
        <p>Learn by building. Contribute to real modules, gain mentorship, and grow with a team that values your spark.</p>
      </div>
    </div>
  </div>
</section>

<section class="form-section" id="join-form">
  <div class="form-container">

         <div className="w3-col l12 m12 s12 ">

          {images.length > 0 ? (
            
<div className="thumbnail-grid">
  {images.map((img, idx) => (
    <div
      key={idx}
      className="thumbnail-tile"
      style={{ backgroundImage: `url("${img}")` }}
    />
  ))}
</div>
          ) : (
            <div className="w3-center w3-padding w3-text-grey">

            </div>
          )}


        </div>
  <div className="w3-col l12 m12 s12 w3-margin  ">
 
    <h2>Promote this Project</h2>
    <p>Tell us a bit about yourself and how you'd like to contribute. 
    <br /> We'll get in touch soon!</p>
</div>
    <form onSubmit={handleContributeSubmit}>
      <div class="form-group">
        <label for="name">Full Name*</label>
        <input type="text" id="name" name="name" required />
      </div>

      <div class="form-group">
        <label for="email">Email Address*</label>
        <input type="email" id="email" name="email" required />
      </div>

      <div class="form-group">
        <label for="role">I’m joining as a…*</label>
        <select id="role" name="role" required>
          <option value="">Select a role</option>
          <option value="entrepreneur">Entrepreneur</option>
          <option value="leader">Leader</option>
          <option value="investor">Investor</option>
          <option value="researcher">Researcher</option>
          <option value="institution">Institutional Partner</option>
          <option value="intern">Intern</option>
        </select>
      </div>

      <div class="form-group">
        <label for="message">Tell us aboutyour interest</label>
        <textarea id="message" name="message" rows="4" placeholder="Your goals, ideas, or questions…"></textarea>
      </div>

      <button type="submit" class="submit-button">Submit Application</button>
    </form>

    <hr />
       <p className="w3-center w3-small w3-600"> Our engagement team will call you to confirm your interest and will book your next appointment
      .</p>
  </div>
</section>

             </div>

      {/* ✅ Success Popup */}
      {showSuccess && (
        <div className="w3-modal" style={{ display: "block" }}>
          <div
            className="w3-modal-content w3-round-large w3-animate-opacity w3-center"
            style={{ maxWidth: "350px", padding: "30px" }}
          >
            <h4 className="w3-text-green">✅ Submitted!</h4>
            <p>
              Thank you for your interest. Our team will contact you shortly.
            </p>
          </div>
        </div>
      )}
    </div>

    </div>
  );
}

// ✅ Simple JS Slider
let slideIndex = 1;
function plusDivs(n) {
  showDivs((slideIndex += n));
}
function showDivs(n) {
  const x = document.getElementsByClassName("mySlides");
  if (x.length === 0) return;
  if (n > x.length) slideIndex = 1;
  if (n < 1) slideIndex = x.length;
  for (let i = 0; i < x.length; i++) x[i].style.display = "none";
  x[slideIndex - 1].style.display = "block";
}

export default ProjectDetail;
